// tslint:disable
/**
 * TermineAPI
 * Public ÖAMTC Termine (Station Mappings) API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface StationMapping
 */
export interface StationMapping {
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    dienststelleId?: string;
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    landesclubId?: string;
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    bezeichnung?: string;
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    plz?: string;
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    ort?: string;
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    adresse?: string;
    /**
     * 
     * @type {string}
     * @memberof StationMapping
     */
    slug?: string;
}

/**
 * StationApi - axios parameter creator
 * @export
 */
export const StationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} stationName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationMappingByName: async (stationName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationName' is not null or undefined
            if (stationName === null || stationName === undefined) {
                throw new RequiredError('stationName','Required parameter stationName was null or undefined when calling getStationMappingByName.');
            }
            const localVarPath = `/station-mappings/{stationName}`
                .replace(`{${"stationName"}}`, encodeURIComponent(String(stationName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationMappings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/station-mappings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationApi - functional programming interface
 * @export
 */
export const StationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} stationName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStationMappingByName(stationName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationMapping>> {
            const localVarAxiosArgs = await StationApiAxiosParamCreator(configuration).getStationMappingByName(stationName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStationMappings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StationMapping>>> {
            const localVarAxiosArgs = await StationApiAxiosParamCreator(configuration).getStationMappings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StationApi - factory interface
 * @export
 */
export const StationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} stationName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationMappingByName(stationName: string, options?: any): AxiosPromise<StationMapping> {
            return StationApiFp(configuration).getStationMappingByName(stationName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationMappings(options?: any): AxiosPromise<Array<StationMapping>> {
            return StationApiFp(configuration).getStationMappings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationApi - object-oriented interface
 * @export
 * @class StationApi
 * @extends {BaseAPI}
 */
export class StationApi extends BaseAPI {
    /**
     * 
     * @param {string} stationName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public getStationMappingByName(stationName: string, options?: any) {
        return StationApiFp(this.configuration).getStationMappingByName(stationName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public getStationMappings(options?: any) {
        return StationApiFp(this.configuration).getStationMappings(options).then((request) => request(this.axios, this.basePath));
    }

}


